import React from "react";
import { Row, Col } from "antd";
import Mention from "./mention";
import { useNavigate } from "react-router-dom";

function Circle() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/register")
  }

  return (
    <section className="circle pb-[40px] px-[20px]">
      <div >
        <Mention limit={3} showCompareButton={false} />
        <div className="flex justify-center">
          <button
            onClick={handleClick}
            className="mt-[45px] text-black font-outfit font-semibold px-6 py-3 rounded-full 
             shadow-md transition-all duration-500 bg-gradient-to-r from-[#00F0FB] via-white to-[#00F0FB]
             bg-[length:200%_200%] bg-left hover:bg-right hover:scale-105"
          >
            Compare Plans & Join Today
          </button>
        </div>
      </div>
    </section>
  );
}

export default Circle;
